import errorMessages from '@common/constants/errorMessages';
import { isAllDigits, isEmpty } from '@common/paymentsUtils/inputValidator';

function isVerificationCodeValid(verificationCode) {
  if (isEmpty(verificationCode) || !isAllDigits(verificationCode) || verificationCode.length !== 5) {
    return errorMessages.PHONE_VERIFICATION_INVALID;
  }
  return errorMessages.CLEAR_ERROR;
}

export function validateAllInputs(verificationCode, setVerificationCode, trackValidationError) {
  const errors: Record<string, any>[] = [];
  const verificationCodeError = isVerificationCodeValid(verificationCode.value);

  if (verificationCodeError) {
    errors.push({ verificationCode: verificationCodeError });
  }
  setVerificationCode({ ...verificationCode, error: verificationCodeError });

  if (errors.length > 0) {
    trackValidationError({ errors });
    return false;
  }
  return true;
}
